export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// Doctor action types
export const REGISTER_DOCTOR_SUCCESS = 'REGISTER_DOCTOR_SUCCESS';
export const REGISTER_DOCTOR_FAIL = 'REGISTER_DOCTOR_FAIL';
export const DOCTOR_LOADED = 'DOCTOR_LOADED';
export const AUTH_DOCTOR_ERROR = 'AUTH_DOCTOR_ERROR';
export const LOGIN_DOCTOR_SUCCESS = 'LOGIN_DOCTOR_SUCCESS';
export const LOGIN_DOCTOR_FAIL = 'LOGIN_DOCTOR_FAIL';
export const LOGOUT_DOCTOR = 'LOGOUT_DOCTOR';
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_BY_ID = 'GET_PROFILE_BY_ID';
export const GET_PROFILES = 'GET_PROFILES';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const CLEAR_PROFILE = 'CLEAR_PROFILE';
export const PROFILE_ERROR = 'PROFILE_ERROR';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';

// User action types
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAIL = 'REGISTER_USER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_USER_ERROR = 'AUTH_USER_ERROR';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAIL = 'LOGIN_USER_FAIL';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_APPOINTMENTS = 'GET_APPOINTMENTS';
export const ADD_APPOINTMENTS = 'ADD_APPOINTMENTS';
export const APPOINTMENT_ERROR = 'APPOINTMENT_ERROR';
export const UPDATE_APPOINTMENTS = 'UPDATE_APPOINTMENTS';
export const ADD_REVIEW = 'ADD_REVIEW';
export const ADD_REVIEW_ERROR = 'ADD_REVIEW_ERROR';
export const REMOVE_REVIEW = 'REMOVE_REVIEW';
export const CLEAR_USER_PROFILE = 'CLEAR_USER_PROFILE';
export const DELETE_USER_ACCOUNT = 'DELETE_USER_ACCOUNT';